<template>
  <div class="p-category container">
    <div class="e-category">
      <h1 v-if="datas.main_category !== '' && datas.sub_category === ''" class="e-category__main">
        {{ datas.main_category }}
      </h1>
      <div v-else-if="datas.main_category !== '' && datas.sub_category !== ''" class="e-category__main">
        {{ datas.main_category }}
      </div>
      <h1 v-if="datas.main_category !== '' && datas.sub_category !== ''" class="e-category__child">
        {{ datas.sub_category }}
      </h1>
    </div>
    <div class="p-category__hot">
      <nuxt-link :to="`/article/${datas.carousel[0].article_id}/`" class="m-card p-category__hot-main" title="前往新聞頁">
        <div v-if="datas.carousel[0].type !== 'general'" class="e-type--bg">
          <span :class="articleType(datas.carousel[0]).style" class="e-type">
            {{ articleType(datas.carousel[0]).text }}
          </span>
        </div>
        <img
          width="672"
          height="353"
          :src="selectImageSize(datas.carousel[0].cover)"
          :alt="datas.carousel ? datas.carousel[0].caption : ''"
          class="m-card__img"
          onerror="this.src='https://static.ctwant.com/images/dist/default_cover_md.png'"
        >
        <h2 class="m-card__title m-card__title--m">
          {{ datas.carousel[0].title }}
        </h2>
        <time :datetime="datas.carousel[0].publish_at" class="e-time">
          <img src="https://static.ctwant.com/images/dist/clock.svg" class="m-card__clock" width="14" height="14" alt="發佈時間圖示">
          {{ datas.carousel[0].publish_at }}
        </time>
      </nuxt-link>
      <div class="l-section__content-list p-category__hot-list">
        <nuxt-link v-for="i in datas.carousel.slice(1, 5)" :key="i.article_id" :to="`/article/${i.article_id}/`" class="m-card-s m-card-s--hot" title="前往新聞頁">
          <!-- 解決 safari 圖片不會自動取高 -->
          <div class="m-card-s__img-container">
            <div v-if="i.type !== 'general'" class="e-type--bg m-card-s__type">
              <span :class="articleType(i).style" class="e-type">
                {{ articleType(i).text }}
              </span>
            </div>
            <LazyImage :src="selectImageSize(i.cover)" :alt="i.caption" class="m-card-s__img" width="135" height="71" />
          </div>
          <div class="m-card-s__content">
            <h2 class="m-card-s__title m-card--mle-3 m-card--mle-p-2">
              {{ i.title }}
            </h2>
            <time :datetime="i.publish_at" class="e-time">
              <img src="https://static.ctwant.com/images/dist/clock.svg" class="m-card__clock" width="14" height="14" alt="發佈時間圖示">
              {{ i.publish_at }}
            </time>
          </div>
        </nuxt-link>
      </div>
    </div>
    <!-- <div class="l-ad__wrapper mb-2 mt-2">
      <div id="div-gpt-ad-1563877821391-0" ref="div-gpt-ad-1563877821391-0" />
    </div> -->
    <div class="p-category__body">
      <div class="p-category__content">
        <div class="l-section">
          <h2 class="l-section__title-with-hr">
            最新消息
          </h2>
          <hr>
          <div class="m-realtime">
            <!-- <span class="m-realtime__date">
              5/30
            </span> -->
            <div class="m-realtime__container">
              <div class="row">
                <nuxt-link v-for="i in datas.news" :key="i.article_id" :to="`/article/${i.article_id}/`" class="col-md-6 col-12" title="前往新聞頁">
                  <div class="m-realtime__item">
                    <h3 class="m-realtime__content">
                      {{ i.title }}
                    </h3>
                    <div class="m-realtime__bottom">
                      <span v-if="i.type !== 'general'" :class="articleType(i).style" class="e-type">
                        {{ articleType(i).text }}
                      </span>
                      <time :datetime="i.publish_at" class="e-time m-realtime__time">
                        <img src="https://static.ctwant.com/images/dist/clock.svg" class="m-card__clock" width="14" height="14" alt="發佈時間圖示">
                        {{ i.publish_at }}
                      </time>
                    </div>
                  </div>
                </nuxt-link>
                <div id="_popIn_recommend_c_onlyAd" />
              </div>
            </div>
          </div>
        </div>
        <!-- 手機側邊欄 -->
        <SideBarForMobile :data="datas" />
        <!-- 手機側邊欄 -->
        <div ref="news" class="l-section">
          <h2 class="l-section__title-with-hr">
            {{ datas.main_category }}{{ datas.sub_category }}相關
          </h2>
          <hr>
          <div class="l-section__content">
            <div class="row">
              <a
                v-for="i in newsData.items"
                :key="i.article_id"
                :href="`/article/${i.article_id}/`"
                class="m-card col-sm-4 col-6"
                target="_blank"
                rel="noreferrer noopener"
                title="另開視窗連結新聞頁"
              >
                <div v-if="i.type !== 'general'" class="e-type--bg m-card__type">
                  <span :class="articleType(i).style" class="e-type">
                    {{ articleType(i).text }}
                  </span>
                </div>
                <LazyImage :src="selectImageSize(i.cover)" :alt="i.caption" class="m-card__img" width="250" height="131" />
                <h3 class="m-card__title m-card--mle-2">
                  {{ i.title }}
                </h3>
              </a>
            </div>
          </div>
        </div>
        <Pagination :total-page="newsData.last_page" :current-page="newsData.current_page" @update="pageChange" />
      </div>
      <!-- 側邊欄 -->
      <SideBar :data="datas" />
      <!-- 側邊欄 -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import articleHelpers from '@/utils/articleHelpers.js'
import adTabIndexRemove from '@/utils/adTabIndexRemove.js'
import Pagination from '@/components/Pagination.vue'
import LazyImage from '@/components/LazyImage.vue'
import SideBar from '@/components/SideBar.vue'
import SideBarForMobile from '@/components/SideBarForMobile.vue'
import scrollToTop from '@/utils/scrollToTop.js'

export default {
  components: {
    Pagination,
    LazyImage,
    SideBar,
    SideBarForMobile
  },
  mixins: [articleHelpers, adTabIndexRemove],
  async asyncData({ $axios, params, route, error, redirect }) {
    // 處理特定路由的301重定向
    if (params.mainCategory === '永續') {
      switch (params.subCategory) {
        case '論壇':
          return redirect(301, '/topic/42/')
        case '新聞':
          return redirect(301, '/topic/43/')
        case '影音':
          return redirect(301, '/topic/44/')
      }
    }

    if (route.path.substr(-1) !== '/' && Object.keys(route.query).length <= 0) {
      return redirect(301, `${route.path}/`)
    }

    const api = $axios.defaults.baseURL
    const pageUrl = `${api}${route.fullPath}`
    let newsUrl = `${api}/pagination${route.fullPath}`

    if (route.query.page) {
      newsUrl = `${api}/pagination${route.fullPath}?page=${route.query.page}`
    }

    try {
      const data = await $axios.$get(pageUrl)
      const newsData = await $axios.$get(newsUrl)
      return { datas: data.data, newsData: newsData.data, main_category: data.data.main_category }
    } catch (e) {
      console.error('Category', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      datas: null,
      newsData: null,
      pageScrollTop: 0
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)
    const websiteCategory = {
      '@context': 'http://schema.org',
      '@type': 'Website',
      author: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      creator: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': hostAndNeedBackslashPath
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/logo.png'
        }
      },
      dateCreated: this.$config.companyCreatedTimeZone,
      datePublished: this.$config.companyCreatedTimeZone,
      dateModified: this.datas.carousel[0].publish_at_time_zone ? this.datas.carousel[0].publish_at_time_zone : '',
      headline: this.pageTitle,
      name: this.pageTitle,
      url: hostAndNeedBackslashPath,
      keywords: this.datas.carousel ? this.datas.carousel.map(item => (item.tags.length > 0 ? item.tags.slice(0, 3).reduce((prev, now) => `${prev}, ${now}`) : [])).slice(0, 3).filter(result => result.length > 0).join(', ') : '',
      description: this.datas.carousel.length > 0 ? this.datas.carousel.map(item => item.title).slice(0, 3).join(', ') : this.pageTitle
    }
    const itemListCategory = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.datas.carousel.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover.md,
          url: `${this.HOST}/article/${item.article_id}`
        }
      })
    }
    return {
      title: this.pageTitle,
      meta: [
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogTitle', property: 'og:title', content: this.pageTitle },
        { hid: 'description', name: 'description', content: websiteCategory.description },
        { hid: 'ogDescription', property: 'og:description', content: websiteCategory.description },
        { hid: 'categoryPublished_time', name: 'pubdate', property: 'category:published_time', itemprop: 'datePublished', content: this.$config.companyCreatedTimeZone },
        { hid: 'categoryModified_time', name: 'lastmod', property: 'category:modified_time', itemprop: 'dateModified', content: websiteCategory.dateModified }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(websiteCategory), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(itemListCategory), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'screenWidth'
      // 'isMobile'
    ]),
    selectImageSize() {
      const sw = this.screenWidth
      return function (imageArr) {
        let imgUrl = null

        if (sw <= this.WIDTH_PAD) {
          imgUrl = imageArr.sm
        } else {
          imgUrl = imageArr.md
        }
        return imgUrl
      }
    },
    pageTitle() {
      const mainCategory = this.datas.main_category
      const subCategory = this.datas.sub_category

      if (subCategory !== '') {
        return `${subCategory} | ${mainCategory} | CTWANT`
      } else {
        return `${mainCategory} | CTWANT`
      }
    }
  },
  watchQuery: true,
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('ad/displayAd')
      this.$store.dispatch('ad/registerAndDisplayPopupAd', { type: this.main_category })
      this.$gtm.push({
        event: 'domMounted',
        pageUrl: this.$route.fullPath,
        pageTitle: this.pageTitle,
        pageCategory: this.main_category
      })

      // if (this.isMobile === false) {
      //   this.$_adTabIndexRemoveFn([
      //     this.$refs['div-gpt-ad-1563877821391-0']
      //   ])
      // }
    })
  },
  updated() {
    if (this.$route.query.page) {
      this.scrollToNews()
    }
  },
  methods: {
    pageChange(page) {
      this.$store.dispatch('ad/displayAd')
    },
    scrollToNews() {
      const offset = 100
      this.pageScrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      const newsPos = this.$refs.news.getBoundingClientRect().top + this.pageScrollTop

      if (this.pageScrollTop > newsPos) {
        scrollToTop(newsPos - offset, 1500, 'easeOutSine')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_category';
</style>
